import * as React from "react"

import { MultiPick, type MultiPickOption, type MultiPickProps } from "./multi-pick"

export interface SinglePickProps
  extends Omit<MultiPickProps, "selected" | "onChange" | "singlePick"> {
  selected?: string
  onChange: (selected?: string) => void
  options: MultiPickOption[]
}

export function SinglePick({ selected, onChange, ...props }: SinglePickProps) {
  const selectedArray = React.useMemo(() => (selected ? [selected] : []), [selected])

  return (
    <MultiPick
      {...props}
      selected={selectedArray}
      onChange={(next) => onChange(next[0])}
      singlePick
    />
  )
}

